import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import SidImg1 from '../../images/testimonial/img-4.jpg'
// import SidImg2 from '../../images/testimonial/img-5.jpg'
import client1 from '../../images/testimonial/client/1.jpg'
import client2 from '../../images/testimonial/client/2.jpg'

import Quote from '../../images/testimonial/quote-2.svg'

const testimonials = [
  {
    id: '01',
    img: client1,
    Des: "YV Reddy Associates and their team were extremely helpful from beginning to end. They are highly creative, professional, and capable of handling all our requirements seamlessly. I strongly recommend YV Reddy Associates for interior design services. Our new home looks absolutely stunning.",
    Title: 'Mr.Madhusudan Naidu',
    Sub: "Builder",
  },
  {
    id: '02',
    img: client2,
    Des: "I am one of the many satisfied customers who have used YV Reddy Associates’ services. They truly understand the value of quality workmanship and professional service. It was a pleasure working with the team, and the execution of my new home exceeded expectations.",
    Title: 'Mr.Jagan Mohan Rao',
    Sub: "Businessman",
  },
  {
    id: '03',
    img: client1,
    Des: "Highly recommended. I was initially hesitant about working with an interior design firm, but YV Reddy Associates made the entire process smooth and stress-free. The final outcome was impressive and well executed.",
    Title: 'K S Rama Rao',
    Sub: "Film Producer",
  },
  {
    id: '04',
    img: client2,
    Des: "Working with YV Reddy Associates has been a positive and rewarding experience. The design team went above and beyond expectations, delivering a space that is not only beautiful but also highly functional and unique.",
    Title: 'Mr.Rajasekhar',
    Sub: "Client",
  },
];



const TestimonialS4 = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:false,
        dots: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                }
            },
        ]
    }
    return (
        <section className={"" + props.hclass}>
            <Slider {...settings} className="testimonial-slider-s3">
                {testimonials.slice(0, 4).map((testimonial, item) => (
                    <div className="item" key={item}>
                        <div className="content">
                            <div className="icon">
                                <img src={Quote} alt="quote" />
                            </div>
                            <h3>“{testimonial.Des}”</h3>
                            <div className="client-wrap">
                                {/* <div className="image">
                                    <img src={testimonial.img} alt="" />
                                </div> */}
                                <div className="text">
                                    <h4>{testimonial.Title}</h4>
                                    <span>{testimonial.Sub}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default TestimonialS4;


